import React, { useEffect, useState } from "react";
import {
  _getBaseUrl,
  _getCSRFTokenValue,
  _getTileShape,
} from "../utils/helper";

const InspiratieFavourite = () => {
  const [posts, setPosts] = useState([]);
  const [favourites, setFavourites] = useState([]);
  const [hoveredId, setHoveredId] = useState(null);

  // Fetch posts whenever favourites changes
  useEffect(() => {
    const fetchNodes = async (ids) => {
      try {
        const csrfToken = await _getCSRFTokenValue();
        const res = await fetch("/api/inspiratiepunten_searchandfilter", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": csrfToken,
          },
          body: JSON.stringify({
            nodeStatus: [true],
            nids: ids,
          }),
        });

        const data = await res.json();
        setPosts(data.posts || []);
      } catch (err) {
        console.error("Fetch error:", err);
      }
    };

    if (favourites.length > 0) {
      fetchNodes(favourites);
    }
  }, [favourites]); // depends on favourites

  // Load favourites from localStorage once
  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("inspiratie-favourites")) || [];
    setFavourites(stored.map(Number));
  }, []);

  // Update localStorage whenever posts change, also to eliminate duplicates and strays
  // useEffect(() => {
  //   console.log("AAA Updating localStorage with current posts:", posts);
  //   const nids = posts.map(post => Number(post.nid));
  //   localStorage.setItem("inspiratie-favourites", JSON.stringify(nids));

  //   const elm = document.getElementById("favorieten-count");
  //   if (elm) {
  //     elm.textContent = `Favorieten (${nids.length})`;
  //   }
  // }, [posts]);


  // Button handler example
  const toggleFavourite = (nid) => {
    let updated;
    if (favourites.includes(nid)) {
      updated = favourites.filter(id => id !== nid);
    } else {
      updated = [...favourites, nid];
    }
    setFavourites(updated);
    localStorage.setItem("inspiratie-favourites", JSON.stringify(updated));
    const elm = document.querySelector(".fav-count");
    if (elm) {
      elm.textContent = 'Favorieten (' + updated.length + ')';
    }
  };

  return (
    <div className="space-y-8">
      {favourites.length === 0 ? (
        <div className="rounded-[20px] px-8 py-16 bg-white">
          <p>Je hebt momenteel geen favorieten.</p>
        </div>
      ) : (
        posts.map((post, index) => {
          const numericNid = Number(post.nid);
          const isFav = favourites.includes(numericNid);

          return (
            <div
              key={numericNid || index}
              className="card-inspiratiepunten-list"
            >
              <div className="rounded-[20px] px-8 py-6 bg-white">
                <div className="flex justify-between items-center gap-8 flex-wrap lg:flex-nowrap">
                  <div className="flex items-center gap-8 flex-wrap">
                    {/* Thumbnail */}
                    <div className="w-full sm:w-auto flex-shrink-0 flex sm:block items-center justify-start gap-6 sm:gap-0">
                      <div className="w-[85px] sm:w-[120px] aspect-square relative mx-auto flex-shrink-0">
                        <div className="absolute bottom-1 -right-1 z-0 sm:hidden">
                          {_getTileShape(post.image_shape, post.color, "85")}
                        </div>
                        <div className="absolute bottom-1 -right-1 z-0 hidden sm:block">
                          {_getTileShape(post.image_shape, post.color, "120")}
                        </div>
                        <img
                          src={post.imageUrl}
                          alt="Voorbeeld"
                          className={`list-thumbnail w-full h-full object-cover relative z-10 clip-path-${post.image_shape}`}
                        />
                      </div>
                      <h2 className="h4 font-sharpgrotesk mb-0 !text-xl sm:hidden flex-grow">{post.title}</h2>
                    </div>

                    {/* Title & Description */}
                    <div>
                      <h2 className="h4 font-sharpgrotesk mb-0 !text-xl hidden sm:block">{post.title}</h2>
                      {post.summary && (
                        <p className="card-inspiratiepunten--summary !text-base hidden sm:block">
                          {post.summary}
                        </p>
                      )}

                      {post.transitieagendaArray.length > 0 && (
                        <div className="flex flex-wrap gap-1">
                          {post.transitieagendaArray.map((ta) => (
                            <div
                              className="border rounded-full px-5 py-2 text-white w-fit text-sm whitespace-nowrap"
                              style={{ backgroundColor: ta.color }}
                            >
                              {ta.name}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Buttons */}
                  <div className="shrink-0 flex justify-between gap-2 w-full lg:w-auto">
                    <button
                      onClick={() => toggleFavourite(numericNid)}
                      onMouseEnter={() => setHoveredId(numericNid)}
                      onMouseLeave={() => setHoveredId(null)}
                      aria-label="heart favourite icon"
                      className={`w-fit flex-shrink-0 flex-grow-0 button-favorieten text-base gap-2 align-bottom py-2.5 px-3.5 rounded-full border relative flex items-center justify-center cursor-pointer bg-white text-cirBlack ${isFav ? "active" : ""}`}
                    >
                      <img
                        src={
                          isFav
                            ? hoveredId === numericNid
                              ? _getBaseUrl("src/assets/inspiratiepunten/icon-heart.svg", true)
                              : _getBaseUrl("src/assets/inspiratiepunten/icon-heart-pink.svg", true)
                            : hoveredId === numericNid
                              ? _getBaseUrl("src/assets/inspiratiepunten/icon-heart-pink.svg", true)
                              : _getBaseUrl("src/assets/inspiratiepunten/icon-heart.svg", true)
                        }
                        alt=""
                      />
                    </button>

                    <a
                      href={`${post.permalink}`}
                      aria-label={`Lees meer ${post.title}`}
                      className="flex text-base gap-5 w-min-content py-2.5 px-6 rounded-full relative justify-center border-solid cursor-pointer align-bottom w-fit items-center bg-cirBlack border border-cirBlack hover:bg-white hover:border-black text-white hover:text-cirBlack nav-icon-after-white"
                    >
                      Lees meer
                    </a>
                  </div>
                </div>
                {/* Flex END */}
              </div>
            </div>
          );
        })
      )}
    </div>
  );

};

export default InspiratieFavourite;
